import { useSelector } from "react-redux";
import { useColorScheme } from "react-native";
import { lightColors, darkColors, ThemeColors } from "../utils/constants/colors";

export type AppTheme = {
  colors: ThemeColors;
  isDark: boolean;
};

export function useAppTheme(): AppTheme {
  const themeMode = useSelector((s: any) => s.configurations.themeMode ?? "system");
  const systemScheme = useColorScheme();

  const isDark =
    themeMode === "dark" ||
    (themeMode === "system" && systemScheme === "dark");

  return { colors: isDark ? darkColors : lightColors, isDark };
}
